import colors from 'lib/constants/resourceColors';

// Administration > Rate Types. Generalized lookup that promotes the old hardcoded labor-type
// constant (['tech','helper','installer']) into a first-class, editable catalog. A rate type
// is any priced line a contract / contract type can carry a rate for: labor classifications
// (category 'labor') plus non-labor rates (trip charge, diagnostics, surcharge, ...).
//
// Modeled on resources/contractTypes.js (admin lookup keyed on a text column, not `id`):
// rate_types has no uuid id, its PK is the `code` VARCHAR, so identifierParam is 'code' and
// `code` is createOnly since it is the FK target for contract_rates / contract_type_rates.
const form = [
    {key: 'code', label: 'Code (Unique ID)', createOnly: true},
    {key: 'name', label: 'Name'},
    // Free-text but conventionally 'labor' | 'fee' | 'surcharge'. 'labor' is the classification
    // axis a future users.rate_type assignment will point at (deferred).
    {key: 'category', label: 'Category', defaultValue: 'labor'},
    // How the amount is read: 'hourly' uses regular + OT; 'flat'/'percent' use the single
    // regular amount (OT left blank).
    {key: 'rate_kind', label: 'Rate Kind', defaultValue: 'hourly'},
    {key: 'sort_order', label: 'Sort Order', type: 'number', defaultValue: 100},
    {key: 'active', label: 'Active', type: 'boolean', defaultValue: true},
];

export default {
    defaults: {
        name: 'Rate Type',
        color: colors.contractTypes,
        identifierParam: 'code',
        formFields: form,
    },

    view: {
        title: (t) => `${t.name || t.code} Rate Type`,
    },

    search: {
        fields: ['code', 'name', 'category', 'rate_kind', 'active', 'updated_at'],
        links: ['new'],
        searchBy: ['code', 'name', 'category'],
        tableProps: {
            rowURL: '/rate_types/:code',
            columns: [
                {heading: 'Code', accessor: 'code'},
                {heading: 'Name', accessor: 'name'},
                {heading: 'Category', accessor: 'category'},
                {heading: 'Kind', accessor: 'rate_kind'},
                {heading: 'Sort', accessor: 'sort_order'},
                {heading: 'Active', accessor: 'active', type: 'boolean'},
            ],
            showHeading: false,
        }
    },
};
